<template>
	<div>
		<div v-if="bg" class="banner" :style="'background-image:url('+bg+');'">
		</div>
		<swiper v-else-if="bgs.length" :options="swiperOption" ref="mySwiper">
			<swiper-slide class="banner" v-for="item in bgs"
				:style="'background-image:url('+item+');'"></swiper-slide>
		</swiper>
	</div>
</template>

<script>
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.min.css'
	export default {
		props: {
			bg: {
				type: String,
				default: ''
			},
			bgs: {
				type: Array,
				default: function(){return []}
			},
			height: {
				type: Number,
				default: 0
			},
		},
		components: {
			swiper,
			swiperSlide
		},
		data() {
			return {
				current: 0,
				swiperOption: {
					loop: false,
					autoplay: 5000,
				}
			}
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;
			}
		},
		watch: {
			current() {}
		}
	}
</script>

<style scoped>
	.banner {
		height: 28.57rem;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
	}
	@media screen and (max-width: 750px) {
		.banner{
			height: 12rem;
		}
	}
	@media screen and (max-width: 500px) {
		.banner{
			height: 10rem;
		}
	}
</style>